import './leasing-details.scss';

import { CircledImage, Modal } from '@/components/Shared/ui';
import type { TAutoCredLeasingResponse } from '@/types/newOrder';

type TProps = {
  isModalOpen: boolean;
  leasingOffer: TAutoCredLeasingResponse;
  onClose: () => void;
};

const LeasingDetails: React.FC<TProps> = ({
  isModalOpen,
  leasingOffer,
  onClose
}) => {
  if (!leasingOffer.comment) return null;
  return (
    <Modal
      centered
      className="leasing-details"
      title={
        <div className="leasing-details__title-wrapper">
          <h3 className="leasing-details__title">Описание решения</h3>
          <div className="leasing-details__title-leasing-company">
            <CircledImage
              src={leasingOffer.leasingCompany.icon}
              alt={leasingOffer.leasingCompany.name}
              size={40}
            />
            {leasingOffer.leasingCompany.name}
          </div>
        </div>
      }
      open={isModalOpen}
      onClose={onClose}
      footer={<></>}
      width={800}
      destroyOnHidden
      mask={{ closable: true }}
    >
      <p className="leasing-details__comment">{leasingOffer.comment}</p>
    </Modal>
  );
};

export default LeasingDetails;
